import React from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import PublishService from 'services/PublishService';
import ModificationService from 'services/ModificationService';
import {PublishConst} from 'constants/PublicationConst';
import GridBlock from 'components/GridBlock';
import {isDemandModification, isDemandPreparing} from 'libs/getDemandStatus';
import clsx from 'clsx';

const style = theme => ({
    root: {},
    error: {
        color: theme.palette.common.error
    },
    minusMargin: {
        marginBottom: theme.spacing(-1),
        textAlign: "center"
    },
})

function NoticeButtons(
    {
        classes,
        id,
        editable,
        ojsAdmin,
        noticePreview,
        ojsPublicationStatus,
        isPublicOjsActive,
        isPreviewOjsActive,
        classesRoot,
        checkNoticeStatus,
        setWorking,
        clearPublishResources
    }) {
    const handlePreviewEUForm = () => {
        window.location.href = noticePreview.url
    }

    const handleSendEU = () => {
        if (isDemandPreparing()) {
            setWorking(true);
            PublishService.publishOjsNotice(id).then((res) => {
                PublishService.checkPublishOjs(id).then(resp => {
                    setWorking(false);
                    checkNoticeStatus();
                });
                clearPublishResources();
            });
        } else if (isDemandModification()) {
            setWorking(true);
            ModificationService.publishOjsNotice(id).then((res) => {
                ModificationService.noticeOjsStatus(id).then(resp => {
                    setWorking(false);
                    checkNoticeStatus();
                });
                clearPublishResources();
            });
        }
    }

    const handleRollback = () => {
        if (isDemandPreparing()) {
            setWorking(true);
            PublishService.rollbackOjsNotice(id).then((res) => {
                PublishService.checkPublishOjs(id).then(resp => {
                    setWorking(false);
                    checkNoticeStatus();
                });
                clearPublishResources();
            });
        } else if (isDemandModification()) {
            setWorking(true);
            ModificationService.rollbackOjsNotice(id).then((res) => {
                ModificationService.noticeOjsStatus(id).then(resp => {
                    setWorking(false);
                    checkNoticeStatus();
                });
                clearPublishResources();
            });
        }
    }

    return (
        <GridBlock
            className={classesRoot}
            direction='column'
            alignItems="center"
        >
            <Button
                onClick={handlePreviewEUForm}
                disabled={!isPreviewOjsActive}
            >
                {Tr('preview_of_eu_form')}
            </Button>

            {(ojsPublicationStatus && ojsPublicationStatus.message && ojsPublicationStatus.status !== PublishConst.UNAVAILABLE) &&
            <Typography className={clsx(classes.minusMargin, {
                [classes.error]: ojsPublicationStatus.status === PublishConst.ERROR || ojsPublicationStatus.status === PublishConst.CONFIRMED
                    || ojsPublicationStatus.status === PublishConst.UE_VALIDATION_ERROR || ojsPublicationStatus.status === PublishConst.NOT_PUBLISHED
            })}>
                {ojsPublicationStatus.message}
            </Typography>
            }

            {(!ojsPublicationStatus || (ojsPublicationStatus.status !== PublishConst.NOT_PUBLISHED && ojsPublicationStatus.status !== PublishConst.UE_VALIDATION_ERROR)) &&
                <Button
                    onClick={handleSendEU}
                    disabled={!isPublicOjsActive || !editable}
                >
                    {Tr('send_eu_publish')}
                </Button>
            }

            {ojsPublicationStatus && ojsPublicationStatus.status === PublishConst.NOT_PUBLISHED &&
            <Button
                onClick={handleRollback}
                disabled={!editable}
            >
                {Tr('send_eu_publish_rollback')}
            </Button>
            }

            {ojsPublicationStatus && ojsPublicationStatus.status === PublishConst.UE_VALIDATION_ERROR &&
            <Button
                onClick={handleRollback}
                disabled={!editable || !ojsAdmin}
            >
                {Tr('send_eu_publish_rollback')}
            </Button>
            }
        </GridBlock>
    )
}

NoticeButtons.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(NoticeButtons);